import { Box, Button, Checkbox, Dialog, FormControl, IconButton, MenuItem, Select, TextField, Typography, Tooltip, styled, Switch, FormControlLabel } from "@mui/material";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";

import _ from "lodash";
import { getDataSource } from "api/ds";
import { ReportTable } from "components/reportTable";
import { loginSelector } from "store/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import Loading from "components/Load";
//import { onChange } from "store/slices/fbs-fbo";
import { delFts, getFile, post, postImage } from "api/apiBridges/httpBridge";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import Scrollbars from "rc-scrollbars";
import useOn from 'components/socketLib/UseOn';
import { MarketClientSelector } from "store/slices/marketClient";
import { get } from "api/apiBridges/httpBridge"
import { useLocalNotifications } from "components/Events";
import { SelectProductTocopy } from "components/EIComponents/ProductInfo";
import ClassicSearch from "components/classicSearch";
import { colors } from 'styles/colors';
import usePreventDoubleClick from "components/AntiDBC";
import { SocketContext } from "components/socketLib/ConnectorSocket";
import { onChangeUploadImage } from "store/slices/uploadImage";
import NoPhoto from '../images/others/noPhoto.png';
import { NumInput, TextInput, TextNumInput } from "components/EIComponents/LittleComponents";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { ShowModal } from "components/Modal";
import { BarcodeSelect, getNextItem, Product, UploadQrButton, UploadTechTaskButton } from "utils/formatters";
import { hoverStyle } from "styles/main";

const CardTableSwitch = styled(Switch)(({ theme }) => ({
    width: '160px',
    height: 30,
    padding: 0,
    margin: 0,
    position: 'relative',

    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 0,
        top: '50%',
        // Начальный отступ слева (2 пикселя)
        transform: 'translateX(2px) translateY(-50%)',

        '&.Mui-checked': {
            // Отступ справа тоже 2 пикселя: 160 - 80 - 2 = 78px смещения
            transform: 'translateX(78px) translateY(-50%)',
            color: '#fff',

            '& .MuiSwitch-thumb:before': {
                content: "'Таблица'",
                left: 8
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
            },
        },
    },

    '& .MuiSwitch-track': {
        borderRadius: 10,
        margin: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        opacity: 1,

        '&::before, &::after': {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            lineHeight: 1,
        },
        '&::before': {
            content: "'Карты'",
            left: 16,
        },
        '&::after': {
            content: "'Таблица'",
            right: 8,
        },
    },

    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        backgroundColor: colors.status.high,
        opacity: 1,
        width: 80,
        height: 25,
        marginBlock: 0,
        padding: 0,
        borderRadius: 10,

        '&::before': {
            position: 'absolute',
            top: '50%',
            left: 16,
            transform: 'translateY(-50%)',
            lineHeight: 1,
            content: "'Карты'",
        },
    },
}));

export function MyProducts() {
    
    const ds = useMemo(() => getDataSource('ClientProducts'), []);
    /** @type {[Array<any>, Function]} */ 
    const [rawData, setRawData] = useState([]);
    // const [data, setData] = useState([]);
    const { user_id, company_id} = useSelector(
            loginSelector
        );
    const { market } = useSelector(MarketClientSelector);

    const [loading, setLoading] = useState(false);
    /** @type {[any, Function]} */ 
    const [loadingProgress, setLoadingProgress] = useState(undefined);
    
    const [open, setOpen] = useState(false);
    /** @type {[any, Function]} */
    const [copyData, setCopyData] = useState(undefined)
    const [openDialogCreate, setOpenDialogCreate] = useState(false);
    const [newSize, setNewSize] = useState(undefined); 
    const [editSize, setEditSize] = useState(undefined); 

    //Настройки Фильтра
    const [checked, setChecked] = useState(false);
    const [PageType, setPageType] = useState(true)
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
            brand: {name: "Брэнд", active: true},
            vendorCode: {name: "Артикул", active: true},
            barcode: {name: "ШК", active: true},
        }
    );
        
    const { showNotification } = useLocalNotifications();

    const fetchData = useCallback(async () => {
        // todo проверка какой маркет выбран
        // добавленный товар исключать путем запроса
        setLoading(true);

        if (market !== "custom") {
          // получаем данные с парсера 
          let res = []
          let isToken = await get('Clients/checkClientAPIKey', {uid:user_id, market:market})
          if (isToken){
            switch (market) {
            case "wb":
                res = await ds.getWBCardAndStocks(user_id);
                break;
            case "ozon":
                res = await ds.getOZONCardAndStocks(user_id);
                break;
          }
          }else {
            showNotification({
                id: 'checkToken', 
                type: 'error', 
                message: 'У вас не указан API ключ.' 
            });
          }       
          
          for (const el of res) {
              //el['expanded'] = [];
              let elsizes = [...el.data.sizes]
              delete el.data.sizes
              el.id=el.nmID || el.group_id 
              let sizes_name = []
              let ttc = 0
              let cqc = 0
              let tcq = 0
              let tempExpanded = []
              elsizes.map((size) => {
                  //console.log('size', size)
                  sizes_name. push(size.title)
                  if (size.techTask?.versions && Object.keys(size.techTask.versions).length >0) ttc++
                  if (size.countQr && parseInt(size.countQr)>0) {cqc++; tcq += parseInt(size.countQr)}
                  let obj = {
                    ...JSON.parse(JSON.stringify(el)),
                    id:`${el.id};${size.barcode}`, 
                    size:{...size, stocks: size.stocks.sort((a,b) => {return b.stocks - a.stocks}), countQr: size.countQr || 0}, 
                  }
                  if (!obj.nmID && size.nmID) {obj.nmID = size.nmID}
                  obj.techTask = {...size.techTask, barcode: size.barcode, title: el.data.title, vendorCode: el.data.vendorCode}
                  obj.qrcode = {id: `${obj.nmID};${size.barcode}`, nmID: obj.nmID, title: obj.data.title, size, company: company_id, count: size.countQr, vendorCode: el.data.vendorCode}
                   
                  obj.data.sizeTitle = size.title
                  obj.data.barcode = size.barcode
                  if (size.vendorCode) {obj.data.vendorCode = size.vendorCode}
                  console.log("obj.data", obj.data)
                  tempExpanded.push(obj)
              })
              el['expanded'] = tempExpanded.sort((a,b) => a.size.barcode.localeCompare(b.size.barcode))
              el.qrcode = {progress: (cqc/el['expanded'].length)*100}
              el.techTask = {progress: (ttc/el['expanded'].length)*100}
              el.data.sizeTitle = sizes_name
          }

          // const sortedRes = [...res].sort((a, b) => {
          //   return b.data.totalCount - a.data.totalCount;
          // });

          console.log("result", res)
          setRawData(res);
        }
        else {
          let res = await get("custom_product/getOnCli", {cid:user_id})
          const sortedRes = res.sort((a, b) => b.nmId - a.nmId)
          for (const el of sortedRes) {
              //el['expanded'] = [];
              let elsizes = [...el.data.sizes]
              delete el.data.sizes
              el.id=el.nmID 
              let sizes_name = []
              let ttc = 0
              let cqc = 0
              let tcq = 0
              let tempExpanded = []
              elsizes.map((size) => {
                  console.log('size', size)
                  sizes_name.push(size.title)
                  if (size.techTask?.versions && Object.keys(size.techTask.versions).length >0) ttc++
                  if (size.countQr && parseInt(size.countQr)>0) {cqc++; tcq += parseInt(size.countQr)}
                  let obj = {
                    ...JSON.parse(JSON.stringify(el)), 
                    // vendorCode: size.vendorCode || el.vendorCode, 
                    id:`${el.nmID};${size.barcode}`, 
                    size:{...size, stocks: size.stocks.sort((a,b) => {return b.stocks - a.stocks}), countQr: size.countQr || 0}, 
                    techTask: {...size.techTask, barcode: size.barcode, title: el.data.title, vendorCode: el.data.vendorCode},
                    qrcode:{id: `${el.nmID};${size.barcode}`, nmID: el.nmID, title: el.data.title, size, market: 1, company: company_id, count: size.countQr, vendorCode: el.data.vendorCode}
                  }
                  obj.data.sizeTitle = size.title
                  obj.data.barcode = size.barcode
                  if (size.vendorCode) {obj.data.vendorCode = size.vendorCode}
                  tempExpanded.push(obj) 
              })
              el['expanded'] = tempExpanded.sort((a,b) => a.size.barcode.localeCompare(b.size.barcode))
              el.qrcode = {progress: (cqc/el['expanded'].length)*100}
              el.techTask = {progress: (ttc/el['expanded'].length)*100}
              el.data.sizeTitle = sizes_name
              
          }

          setRawData(sortedRes);
        }
                
        setLoading(false);
      }, [ds, market]);

    useEffect(() => {
        fetchData();
    }, [market]);

    useOn('updateCountPages', ($data) => {
      console.log('USE ON', $data)
      let tmp = JSON.parse(JSON.stringify(rawData))
      console.log("tmp", tmp)
      if ($data) {
        // const index = tmp.findIndex((el) => String(el.nmID) === String($data.nmID));
        const index = tmp.findIndex((el) => el['expanded'].findIndex((fel) => fel.size.barcode === $data.size ) > -1  );
        if (index !== -1) {
          const idx = tmp[index]['expanded'].findIndex((el) => el.size.barcode === $data.size);
          if (idx !== -1 ) {
            tmp[index]['expanded'][idx].size.countQr = $data.count;

            tmp[index]['expanded'][idx].qrcode.count = $data.count;

            let new_tcq = 0;
            let new_cqc = 0;
                
            for (const expandedEl of tmp[index]['expanded']) {
                const count = parseInt(expandedEl.size.countQr) || 0;
                new_tcq += count;
                if (count > 0) {
                    new_cqc++;
                }
            }

            // tmp[index].size.countQr = new_tcq;
            tmp[index].qrcode.progress = (new_cqc / tmp[index]['expanded'].length) * 100;

            new_tcq = 0;
            new_cqc = 0;

            setRawData(tmp);
          }
        }
      }
    });


    const changeTableRow = async ($data) => {
      
      if ($data.changeBarcode) {
        changeBarcode($data)
        return
      }
      if ($data.del) {
        delTechTask($data)
        return
      }
      changeTechText($data)
    }

    const changeBarcode = async ($data) => {
      setLoading(true)
      if ($data.row?.expId) {
          let foundIndex = -1;
          let foundExpIndex = -1;
          
          // Находим индексы
          foundIndex = rawData.findIndex((el) => String(el.id) === String($data.row.id));
          if (foundIndex !== -1) {
            foundExpIndex = rawData[foundIndex].expanded.findIndex((el) => String(el.id) === String($data.row.expId));
          }
          
          if (foundExpIndex !== -1) {
            await post("barcodes/update", {
                uid: market === "wb" ? 
                  rawData[foundIndex].expanded[foundExpIndex].size.chrtID: 
                  rawData[foundIndex].expanded[foundExpIndex].size.ozonID,
                barcode: $data.changeBarcode,
                barcodes: rawData[foundIndex].expanded[foundExpIndex].size.barcodes,
                client_id: user_id,
                market
              })
              await fetchData()
          }
      }
    }

    const delTechTask = async ($data) => {
      if ($data.row?.expId) {
        let foundIndex = -1;
        let foundExpIndex = -1;
        
        // Находим индексы
        foundIndex = rawData.findIndex((el) => String(el.id) === String($data.row.id));
        if (foundIndex !== -1) {
          foundExpIndex = rawData[foundIndex].expanded.findIndex((el) => String(el.id) === String($data.row.expId));
        }
        
        if (foundExpIndex !== -1) {
          //запоминаем матаданные
          const barcode = rawData[foundIndex].expanded[foundExpIndex].size.barcode;
          const title = rawData[foundIndex].data.title
          const vendorCode = rawData[foundIndex].data.vendorCode
          
          
          //Проверяем, нет ли уже существующих сделок с этим тз
          let useInDeals = await get('Deal/checkTZ', {
              tz: $data.version, 
              nmID: rawData[foundIndex].expanded[foundExpIndex].nmID,
              barcode: rawData[foundIndex].expanded[foundExpIndex].size.barcode,
              market
            }
          )

          if (useInDeals.message) {
            showNotification({
              id: 'nocandeltz', 
              type: 'warning', 
              message: 'Нельзя удалить ТЗ, которе используется в сделках' 
            });
            return 
          }
          
          let updatedData =  await post("techTask/delOnVers", {bar: barcode, cid: user_id, market: market, version: $data.version})

          // Обновляем состояние
          setRawData(prevRawData => {
            const newData = JSON.parse(JSON.stringify(prevRawData));
            
            // Обновляем techTask

            let resversions = Object.keys(updatedData.versions)
            newData[foundIndex].expanded[foundExpIndex].techTask = {
              barcode: barcode,
              title: title,
              vendorCode:vendorCode,
              versions: updatedData.versions,
              TZV: resversions.length>0? resversions[resversions.length-1]: 'main'
            };

            let new_ttc = 0;
            for (const expandedEl of newData[foundIndex]['expanded']) {
              if (expandedEl.techTask?.versions && Object.keys(expandedEl.techTask?.versions).length >0) new_ttc++
            }
            
            newData[foundIndex].techTask.progress = 
              (new_ttc / newData[foundIndex]['expanded'].length) * 100;
            
            return newData;
          });
          showNotification({
            id: 'deltzsuccess', 
            type: 'success', 
            message: 'ТЗ успешно удалено' 
          });
        }
      }
    };

    // Обработка изменений технического задания
    const changeTechText = async ($data, updateLocal = true, noNotif = false) => {
      if ($data.swap) {
        console.log("$data.swap", $data.swap)
        let foundIndex = -1;
        let foundExpIndex = -1;
        
        // Находим индексы
        foundIndex = rawData.findIndex((el) => String(el.id) === String($data.row.id));
        if (foundIndex !== -1) {
          foundExpIndex = rawData[foundIndex].expanded.findIndex((el) => String(el.id) === String($data.row.expId));
        }

        if (foundExpIndex !== -1) {
          rawData[foundIndex].expanded[foundExpIndex].techTask.TZV = $data.swap
        }
        return
      }
      if (!$data.copy) {
        console.log("changeTechText", $data);
        
        if ($data.row?.expId) {
          let foundIndex = -1;
          let foundExpIndex = -1;
          
          // Находим индексы
          foundIndex = rawData.findIndex((el) => String(el.id) === String($data.row.id));
          if (foundIndex !== -1) {
            foundExpIndex = rawData[foundIndex].expanded.findIndex((el) => String(el.id) === String($data.row.expId));
          }
          
          if (foundExpIndex !== -1) {
            console.log("AAAAAAAAAA", JSON.parse(JSON.stringify(rawData[foundIndex].expanded[foundExpIndex])))
            //запоминаем матаданные
            const barcode = rawData[foundIndex].expanded[foundExpIndex].size.barcode;
            const title = rawData[foundIndex].data.title
            const vendorCode = rawData[foundIndex].data.vendorCode
            
            //Проверяем, существовала ли ранее такая версия
            const isCreating = !rawData[foundIndex].expanded[foundExpIndex].techTask || (
              !rawData[foundIndex].expanded[foundExpIndex].techTask.versions?.[$data.version]?.text &&
              !rawData[foundIndex].expanded[foundExpIndex].techTask.versions?.[$data.version]?.services &&
              !rawData[foundIndex].expanded[foundExpIndex].techTask.versions?.[$data.version]?.print
            )

            console.log('TZ NMID BARCODE',rawData[foundIndex].expanded[foundExpIndex].nmID
                  , rawData[foundIndex].expanded[foundExpIndex].size.barcode)
            // Выполняем запрос на создание
            if (isCreating) {
              await post('techTask/create', {
                barcode: barcode,
                client_id: user_id,
                market,
                text: $data.text,
                services: $data.services,
                print: $data.print,
                version: $data.version,
                comment: $data.comment,
                fbs: $data.fbs,
                hide: $data.hide,
              });
              if (!noNotif) {
                showNotification({
                  id: 'fieldsErr', 
                  type: 'success', 
                  message: 'ТЗ успешно создано' 
                });
              }
            } 
            else {
              //Проверяем, нет ли уже существующих сделок с этим тз
              //todo
              let useInDeals = await get('Deal/checkTZ', {
                  tz: $data.version, 
                  nmID: rawData[foundIndex].expanded[foundExpIndex].nmID,
                  barcode: rawData[foundIndex].expanded[foundExpIndex].size.barcode,
                  market
                }
              )

              console.log("TT", $data.services)
              console.log("TT1", rawData[foundIndex].expanded[foundExpIndex].techTask.versions[$data.version]?.services)
              console.log("TT2", !_.isEqual($data.services, rawData[foundIndex].expanded[foundExpIndex].techTask.versions[$data.version]?.services))
              //Но если обновлен только комментарий, то просто обновляем
              if (
                useInDeals.message &&
                ( 
                  $data.text !== rawData[foundIndex].expanded[foundExpIndex].techTask.versions[$data.version]?.text ||
                  !_.isEqual($data.services, rawData[foundIndex].expanded[foundExpIndex].techTask.versions[$data.version]?.services) ||
                  $data.print !== rawData[foundIndex].expanded[foundExpIndex].techTask.versions[$data.version]?.print
                )
              ) {
                $data.version = `alt_${Object.keys(rawData[foundIndex].expanded[foundExpIndex].techTask.versions).length+1}`
                await post('techTask/create', {
                  barcode: barcode,
                  client_id: user_id,
                  market,
                  text: $data.text,
                  services: $data.services,
                  print: $data.print,
                  version: $data.version,
                  comment: $data.comment,
                  fbs: $data.fbs,
                  hide: $data.hide
                });
                showNotification({
                  id: 'fieldsErr', 
                  type: 'success', 
                  message: 'Альтернативаная версия ТЗ успешно создана' 
                });
              }
              else {
                await post('techTask/update', {
                  barcode: barcode,
                  client_id: user_id,
                  market,
                  text: $data.text,
                  services: $data.services,
                  print: $data.print,
                  version: $data.version,
                  comment: $data.comment,
                  fbs: $data.fbs,
                  hide: $data.hide,
                });
                showNotification({
                  id: 'fieldsErr', 
                  type: 'success', 
                  message: 'ТЗ успешно обновлено' 
                });
              }
            }
            if (updateLocal) {
              let updatedData = await get("techTask/getOnProduct", {bar: barcode, cid: user_id, market: market})
              // Обновляем состояние
              setRawData(prevRawData => {
                const newData = JSON.parse(JSON.stringify(prevRawData));
                
                // Обновляем techTask

                newData[foundIndex].expanded[foundExpIndex].techTask = {
                  barcode: barcode,
                  title: title,
                  vendorCode:vendorCode,
                  versions: updatedData.versions,
                  TZV: $data.version
                };
                //console.log('AAAAAAAAAAA', newData[foundIndex].expanded[foundExpIndex].techTask)
                // Пересчитываем прогресс
                let new_ttc = 0;
                for (const expandedEl of newData[foundIndex]['expanded']) {
                  if (expandedEl.techTask?.versions && Object.keys(expandedEl.techTask?.versions).length >0) new_ttc++
                }
                
                newData[foundIndex].techTask.progress = 
                  (new_ttc / newData[foundIndex]['expanded'].length) * 100;
                
                return newData;
              });
            }
          }
        }
      } else {
        console.log("copyData", $data)
        setCopyData(JSON.parse(JSON.stringify($data)));
        setOpen(true);
      }
    };

    const copyTechTask = async (list) => {
        console.log("copyTechTask", list)

        const $copy = async (tmp, el) => {
          let [ELID, bc] = el.split(';')
          let idx = tmp.findIndex((fel) => String(fel.id) === ELID)
          let expidx = tmp[idx]['expanded'].findIndex((ffel) => String(ffel.size.barcode) === bc)
          let vers = 'main'
          if (idx > 0 && expidx > 0 && tmp[idx]?.['expanded']?.[expidx]?.techTask?.versions) {
            let versList = Object.keys(tmp[idx]['expanded'][expidx].techTask.versions)
            console.log("versList",versList)
            vers = getNextItem(versList)
          }
          
          await changeTechText({...copyData, version: vers, row: {expId: el, id: ELID}}, true, true)
          let updatedData = await get("techTask/getOnProduct", {bar: tmp[idx]['expanded'][expidx].size.barcode, cid: user_id, market: market})
          tmp[idx]['expanded'][expidx].techTask = {
            barcode: tmp[idx]['expanded'][expidx].size.barcode,
            title: tmp[idx]['expanded'][expidx].data.title,
            vendorCode: tmp[idx]['expanded'][expidx].data.vendorCode,
            versions: updatedData.versions,
            TZV: vers
          }
          let new_ttc = 0;
          for (const expandedEl of tmp[idx]['expanded']) {
            if (expandedEl.techTask?.versions && Object.keys(expandedEl.techTask?.versions).length >0) new_ttc++
          }
          tmp[idx].techTask.progress = (new_ttc / tmp[idx]['expanded'].length) * 100;
        } 

        const total = list.length
        let completed = 0

        const updateProgress = () => {
          completed++
          // Вычисляем процент: от 1 до 100
          const percent = Math.max(1, Math.min(100, Math.round((completed / total) * 100)))
          setLoadingProgress(percent)
        }

        delete copyData.copy
        setLoading(true)
        setLoadingProgress(0)
        let tmp = JSON.parse(JSON.stringify(rawData))
        if (list.length > 500) {
          for (let el of list) {
            await $copy(tmp, el)
            updateProgress()
          } 
        }
        else {
          await Promise.all(list.map(async (el) => {
            await $copy(tmp, el)
            updateProgress()
          }))
        }
        // for (let el of list) {
        //   let [ELID, bc] = el.split(';')
        //   let versList = Object.keys(tmp.find((fel) => String(fel.id) === ELID)['expanded'].find((ffel) => String(ffel.size.barcode) === bc).techTask.versions)
        //   console.log("versList",versList)
        //   await changeTechText({...copyData, version: getNextItem(versList), row: {expId: el, id: ELID}})
        // }
        setRawData(tmp)
        setLoading(false)
        setLoadingProgress(undefined)
        showNotification({
          id: 'succesCopy', 
          type: 'success', 
          message: 'ТЗ успешно скопировано' 
        });
        // setCopyData(undefined)
    }

    const newCustomProduct = async ($data) => {
        await post("custom_product/create", { ...$data, client_id: user_id });
        fetchData()
    };

    
    const newCustomProductSize = async ($data, parent) => {
        console.log("$data", $data)
        console.log("parent", parent)
        let obj = {
          nmID: parent.nmID,
          photo: parent.data.photo || "",
          title: parent.data.title,
          color: parent.data.color,
          material: parent.data.material,
          size: $data.size,
          vendorCode: parent.data.vendorCode,
          barcode: $data.barcode,
          url: parent.data.url,
          brand: parent.data.brand,
          dimensions:parent.data.dimensions,
          client_id: user_id
        }
        await post("custom_product/create", obj);
        fetchData()
    };

    const editCustomProductSize = async ($data) => {
        console.log("$data", $data)
        await post("custom_product/update", { ...$data, client_id: user_id });
        fetchData()
    };

    const delSize = async (item) => {
      console.log('del', item)
      await post("custom_product/del", {id: item.size.realId});
      fetchData()
    }

    const handleClickDelSize = (item) => {
            ShowModal('Удалить товар', 
            <div>Вы уверены, что хотите удалить товар?</div>, 
            async () => {
                try {
                delSize(item)
                }
                catch (err) {}
                finally {}
                
            });
        }

    console.log('MY PROD DATA', rawData.length)
    const totalSKU = rawData.reduce((sum, item) => {
      const expandedLength = Array.isArray(item.expanded) ? item.expanded.length : 0;
      return sum + expandedLength;
    }, 0);

    const totalTechTask = rawData.reduce((total, row) => {
      if (!Array.isArray(row.expanded)) return total;
        const countInRow = row.expanded.filter(item => {
        const versions = item.techTask?.versions;
        return (
          versions && 
          typeof versions === 'object' && 
          Object.keys(versions).length > 0
        );
      }).length;

      return total + countInRow;
    }, 0);

    if (loading && rawData.length === 0) {
      return <Loading></Loading>
    }

    return (
        <Box sx={{height: '100%' }}>    
          <Dialog
              open={open}
              maxWidth='lg'
              PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
              onClose={() => { setOpen(false) }}
          >
              <div style={{ height: '620px', width: '1000px' }}>
                  <SelectProductTocopy data={rawData.flatMap((el) => el.expanded).filter((el) => el.id !== copyData?.row?.expId)} cancel={setOpen} onCopy={(list) => {copyTechTask(list)}}></SelectProductTocopy>
              </div>
          </Dialog>
          <Dialog
              open={openDialogCreate}
              maxWidth='lg'
              PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
              onClose={() => { setOpenDialogCreate(false) }}
          >
              <div style={{ height: '600px', width: '350px' }}>
                  {/* <AddProductToNewDeal data={data} cancel={setOpenDialog} onSave={onAddProduct}></AddProductToNewDeal> */}
                  <CreateCustomProduct create={(inData) => {newCustomProduct(inData)}} cancel={setOpenDialogCreate}></CreateCustomProduct>
              </div>
          </Dialog>
          <Dialog
              // @ts-ignore
              open={newSize}
              maxWidth='lg'
              PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
              onClose={() => { setNewSize(undefined) }}
          >
              <div style={{ height: '600px', width: '350px'}}>
                  {/* <AddProductToNewDeal data={data} cancel={setOpenDialog} onSave={onAddProduct}></AddProductToNewDeal> */}
                  <CreateCustomProduct create={(inData, parent) => {newCustomProductSize(inData, parent)}} cancel={(data) => setNewSize(undefined)} parent={newSize}></CreateCustomProduct>
              </div>
          </Dialog>
          <Dialog
              // @ts-ignore
              open={editSize}
              maxWidth='lg'
              PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
              onClose={() => { setEditSize(undefined) }}
          >
              <div style={{ height: '600px', width: '350px', padding: '12px' }}>
                  {/* <AddProductToNewDeal data={data} cancel={setOpenDialog} onSave={onAddProduct}></AddProductToNewDeal> */}
                  <CreateCustomProduct create={(inData) => {editCustomProductSize(inData)}} cancel={(data) => setEditSize(undefined)} edit={editSize}></CreateCustomProduct>
              </div>
          </Dialog>

          <div style={{ height: "5%", display: 'flex', width: '100%', padding: 'calc(2% - 5px) 1% 1% 1%', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{display: "flex", flexDirection: 'row', alignItems: 'center'}}>
                  <ClassicSearch
                      setChecked={setChecked}
                      setFilter={setFilter}
                      checked={checked}
                      // @ts-ignore
                      fields={filterFields}
                      // @ts-ignore
                      setFields={setFilterFields}
                  />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                  {/* <FormControlLabel label={undefined} sx={{ padding: 0, margin: 0, display: 'flex', flexDirection: 'row', justifyContent: 'center'}}
                      control={<CardTableSwitch defaultChecked={PageType} onChange={(e) => setPageType(e.target.checked)} />}
                  /> */}
                  <Box sx={{
                    zIndex: 10,
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    padding: '15px 20px',
                    borderRadius: '10px',
                    minWidth: '250px',
                    height: '36px', 
                    justifyContent: 'center'
                  }}>
                      {loading? <Loading></Loading>: 
                      <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center', flexDirection: "row"}}>
                          <Typography sx={{ fontSize: '11pt', whiteSpace: 'nowrap' }}>
                              SKU: {totalSKU} шт.
                          </Typography>
                          <Typography sx={{ fontSize: '11pt', whiteSpace: 'nowrap' }}>
                              Товаров: <Typography component="span" sx={{ fontSize: '11pt', color: 'inherit' }}>{rawData.length} шт.</Typography>
                          </Typography>
                          <Typography sx={{ fontSize: '11pt' }}>
                              Заполнено ТЗ: <Typography component="span" sx={{ fontSize: '11pt', color: 'inherit' }}>в {totalTechTask} из {totalSKU} SKU</Typography>
                          </Typography>
                      </Box>
                      }
                  </Box>
                  {market === "custom" && 
                    <Button variant="contained" onClick={() => { setOpenDialogCreate(true) }} sx={{textTransform: 'none', fontWeight: 'bold', backgroundColor: colors.elements, borderRadius: "10px", width: "150px" }}>{`Новый товар`}</Button>
                  }
            </div>
        </div>

        <div style={{
            width: '98%', 
            height: 'calc(89% + 5px)', 
            overflow: 'hidden',
            margin: "1%",
            borderRadius: "10px",
            backgroundColor: PageType? "white": "transparent"
        }}>
            {loading? <Loading progress={loadingProgress}></Loading>: 
              <Scrollbars
                // autoHeight
                // autoHeightMax={"98%"}
                style={{ width: '100%', height: '100%', borderRadius: "10px" }} 
              >
                <div style={{ paddingBottom: '20px', opacity: loading ? 0.5 : 1, pointerEvents: loading ? 'none' : 'all' }}>
                  {PageType? 
                    <ReportTable
                      ds={ds}
                      data={
                        !checked 
                          ? rawData 
                          : rawData
                              .map((el) => {
                                const tf = filter.toLowerCase();
                                const active = filterFields;

                                // Проверяем совпадения по основным полям
                                const matchesTitle = 
                                  active.title.active &&
                                  el.data?.title &&
                                  String(el.data.title).toLowerCase().includes(tf);

                                const matchesBrand = 
                                  active.brand.active &&
                                  el.data?.brand &&
                                  String(el.data.brand).toLowerCase().includes(tf);

                                const matchesVendorCode = 
                                  active.vendorCode.active &&
                                  el.data?.vendorCode &&
                                  String(el.data.vendorCode).toLowerCase().includes(tf);

                                // Проверяем, есть ли среди штрихкодов хотя бы одно совпадение
                                let matchesBarcode = false;
                                if (active.barcode.active && el.expanded) {
                                  matchesBarcode = el.expanded.some(fel =>
                                    fel.size?.barcodes?.some(bel =>
                                      String(bel).toLowerCase().includes(tf)
                                    )
                                  );
                                }

                                const hasMainMatch = matchesTitle || matchesBrand || matchesVendorCode;
                                const onlyBarcodeMatch = matchesBarcode && !hasMainMatch;

                                // Если нет ни одного совпадения — элемент не отображаем
                                if (!hasMainMatch && !onlyBarcodeMatch) return null;

                                // Если совпадение только по штрихкоду — фильтруем expanded
                                if (onlyBarcodeMatch && active.barcode.active && el.expanded) {
                                  const newEl = { ...el };
                                  newEl.expanded = el.expanded.filter(fel =>
                                    fel.size?.barcodes?.some(bel =>
                                      String(bel).toLowerCase().includes(tf)
                                    )
                                  );
                                  return newEl;
                                }

                                // Во всех остальных случаях (совпадение по основным полям) возвращаем элемент без изменений
                                return el;
                              })
                              .filter(el => el !== null)
                      }
                      onFormatterChange={changeTableRow}
                      autoPagination={15}
                      aditionalAction={
                        market === "custom"? 
                          [
                              {
                                  action: (item) => {setNewSize(item)},
                                  ui: () => {return (
                                      <AddIcon
                                          sx={{
                                              transition: 'all 0.3s ease',
                                              '&:hover': hoverStyle
                                          }}
                                      />
                                  )}
                              },
                              {
                                  exp: true,
                                  action: (item) => {handleClickDelSize(item)},
                                  ui: () => {return (
                                      <DeleteIcon
                                          sx={{
                                              transition: 'all 0.3s ease',
                                              '&:hover': hoverStyle
                                          }}
                                      />
                                  )}
                              },
                              {
                                  exp: true,
                                  action: (item) => {setEditSize(item)},
                                  ui: () => {return (
                                      <EditIcon
                                          sx={{
                                              transition: 'all 0.3s ease',
                                              '&:hover': hoverStyle
                                          }}
                                      />
                                  )}
                              }
                          ]
                        : undefined
                      }
                    />
                  :
                      <div style={{width: "100%", display: 'flex', flexDirection: "row", alignItems: 'center', flexWrap: 'wrap', gap: "15px"}}>
                        {
                          rawData.map((gel) => 
                            gel.expanded.map((el) => {
                              return (
                                 <div key={`pritem${el.id}`} style={{backgroundColor: 'white', borderRadius: "10px", padding: "5px", width: '24%', display: 'flex', flexDirection: 'column'}}>
                                    <div style={{width: "100%", marginBottom: "5px", display: 'flex', flexDirection: "row"}}>
                                      <div style={{width: "86%"}}>
                                        <Product value={el.data} desc={undefined}/>
                                      </div>
                                      <div style={{width: "14%", display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                        <UploadQrButton value={el.qrcode} desc={undefined} size={"40px"}/>
                                      </div>
                                    </div>
                                    <div style={{width: "100%", marginBottom: "5px", display: 'flex', flexDirection: "column", gap: "5px"}}>
                                      <div style={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                                        <Typography sx={{width: "69%", fontSize: '12pt', lineHeight: '14pt', fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical'}}>Баркод:</Typography>
                                        <div style={{width: "30%"}}>
                                          <BarcodeSelect barcode={el.size.barcode} barcodes={el.size.barcodes} aline="flex-end" onChange={(b) => {changeTableRow({id: el.id, changeBarcode: b})}}/>
                                        </div>
                                      </div>
                                      <div style={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                                        <Typography sx={{fontSize: '12pt', lineHeight: '14pt', fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical'}}>Бренд:</Typography>
                                        <Typography sx={{fontSize: '12pt', lineHeight: '14pt', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', maxWidth: "70%"}}>{Array.isArray(el.data.brand)? el.data.brand.join(', '): el.data.brand}</Typography>
                                      </div>
                                      <div style={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                                        <Typography sx={{fontSize: '12pt', lineHeight: '14pt', fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical'}}>Артикул:</Typography>
                                        <Typography sx={{fontSize: '12pt', lineHeight: '14pt', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', maxWidth: "70%"}}>{Array.isArray(el.data.vendorCode)? el.data.vendorCode.join(', '): el.data.vendorCode}</Typography>
                                      </div>
                                      <div style={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                                        <Typography sx={{fontSize: '12pt', lineHeight: '14pt', fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical'}}>Размер: </Typography>
                                        <Typography sx={{fontSize: '12pt', lineHeight: '14pt', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', maxWidth: "70%"}}>{Array.isArray(el.data.sizeTitle)? el.data.sizeTitle.join(', '): el.data.sizeTitle}</Typography>
                                      </div>
                                      <div style={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                                        <Typography sx={{fontSize: '12pt', lineHeight: '14pt', fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical'}}>Цвет:</Typography>
                                        <Typography sx={{fontSize: '12pt', lineHeight: '14pt', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', maxWidth: "70%"}}>{Array.isArray(el.data.color)? el.data.color.join(', '): el.data.color}</Typography>
                                      </div>
                                    </div>
                                    <UploadTechTaskButton value={el.techTask} id={el.id} onChange={changeTableRow} desc={undefined}/>
                                </div>
                              )
                            })
                          )
                        }

                      </div>
                  }
                </div>
              </Scrollbars>
            }
          </div>

        </Box>
    );

}


function CreateCustomProduct({create, cancel, parent = undefined, edit = undefined}) {
    const [isLoading, setIsLoading] = useState(false);
    
    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();
    /** @type {[any, Function]} */
    const [data, setData] = useState({
        photo: "",
        blob: "",
        title: '',
        color: [],
        material: [],
        size: '',
        vendorCode: "",
        barcode: undefined,
        url: '',
        brand: '',
        dimensions: {
            length: '',
            height: '',
            width: ''
        },
    })

    const dispatch = useDispatch();
    const { socket } = useContext(SocketContext);
    const onSubmit = useCallback((data) => {
        dispatch(onChangeUploadImage(data));
    }, [dispatch]);
    const { user_id} = useSelector(
        loginSelector
    );


    useEffect(() => {

        const loadPhoto = async (obj) => {
            let photo = await getFile("png", {path:obj.photo});
            if (photo) {
                obj.blob = photo
            }
            setData(obj)
            setIsLoading(false)

        }

        if (edit) {
          console.log("edit", edit)
          let obj = {
            // @ts-ignore
            id: edit.size.realId,// @ts-ignore
            nmID: edit.nmID,// @ts-ignore
            photo: edit.data.photo,
            blob: "",// @ts-ignore
            title: edit.data.title,// @ts-ignore
            color: edit.data.color,// @ts-ignore
            material: edit.data.material,// @ts-ignore
            size: edit.size.title,// @ts-ignore
            vendorCode: edit.data.vendorCode,// @ts-ignore
            barcode: edit.size.barcode,// @ts-ignore
            url: edit.data.url,// @ts-ignore
            brand: edit.data.brand,// @ts-ignore
            dimensions: edit.data.dimensions
          }
          setIsLoading(true)
          loadPhoto(obj)
        }
    }, [edit]);

    useOn('uploadCPImage', async ($data) => {
        console.log("uploadCPImage", $data);
        let photo = await getFile("png", {path:$data.path});
        
        if (photo) {

            let tmp = JSON.parse(JSON.stringify(data))
            tmp.photo = $data.path
            tmp.blob = photo
            setData(tmp)
            
            showNotification({
                id: 'test', 
                type: 'success', 
                message: 'Изображение загруженно' 
            });
        }
    });

    const handleFileUpload = useCallback(async (event, dataPath) => {
        let selectedFiles = Array.from(event.target.files);
        if (selectedFiles && selectedFiles.length > 0) {
          let rightFiles = []
          selectedFiles.map((file) => {
          if (file.type === "image/png" || file.type === "image/jpeg") {
              rightFiles.push(file)
          }
          else {
              showNotification({
              id: 'uploadDealImageErr', // Уникальный идентификатор
              type: 'error', // Тип уведомления
              message: `Файл ${file.name} неподдерживаемого типа` // Текст сообщения
              });
          }
          })
          if (rightFiles.length > 0 ) {
              onSubmit({ upload: true });
                showNotification({
                id: 'uploadCPImage', // Уникальный идентификатор
                type: 'info', // Тип уведомления
                message: 'Загрузка' // Текст сообщения
              });
              postImage(rightFiles, socket.id, {user_id, role:`custom_product`, content_type:"loadCPImage", dataPath}).then(() => { selectedFiles = []; onSubmit({ upload: false });});
              setIsLoading(true);
          }
        }
        else {
            setIsLoading(false);
        }
    }, [onSubmit]);

    const handleFileDel = async (dataPath) => {
        let tmp = JSON.parse(JSON.stringify(data))
        let old = _.get(tmp, dataPath)
        _.set(tmp, dataPath, "")
        _.set(tmp, 'blob', undefined)
        if (old) {
            await delFts('/delete-file', {path:[old], taskType: "delImage"}, socket.id)
        }
        setData(tmp)
    }

    const goBind = () => {
        const isValid =true//todo

        if (isValid) {
            if (parent) {
              create(data, JSON.parse(JSON.stringify(parent)))
            }
            else {create(data);}
            cancel(false);
        } else {
            showNotification({
                id: 'valueError', 
                type: 'error', 
                message: 'Заполните все поля' 
            });
        }
    }

    const editNumValue = (path, val) => {
        let num = parseInt(val)
        if (!isNaN(num)) {
            let tmp = JSON.parse(JSON.stringify(data))
            _.set(tmp, path, num)
            setData(tmp)
        }
    }
    const editTextValue = (path, val) => {
        let tmp = JSON.parse(JSON.stringify(data))
        _.set(tmp, path, val)
        setData(tmp)
    }

    const addNewColor = () => {
      let tmp = JSON.parse(JSON.stringify(data))
      tmp.color.push("")
      setData(tmp)
    }

    const delColor = (ind) => {
      let tmp = JSON.parse(JSON.stringify(data))
      tmp.color.splice(ind, 1);
      setData(tmp)
    }

    const addNewMaterial = () => {
      let tmp = JSON.parse(JSON.stringify(data))
      tmp.material.push("")
      setData(tmp)
    }

    const delMaterial = (ind) => {
      let tmp = JSON.parse(JSON.stringify(data))
      tmp.material.splice(ind, 1);
      setData(tmp)
    }

    return (
        <Box
            sx={{
                height: '100%',
                display: "flex",
                flexDirection: "column",
                p: 1,
                gap: 2,
                overflow: "hidden"
            }}
        >
            {/* Заголовок */}
            <Typography
                variant="h4"
                sx={{
                    fontWeight: "bold",
                    color: "text.primary",

                }}
            >
                Кастомный товар
            </Typography>
            <Scrollbars style={{ marginLeft:'10px' }}>
                <div style={{display:"flex", flexDirection: 'column', height: "100%", padding: '10px'}}>
                  {!parent &&
                    <>
                    {data.blob? (
                        <div style={{ width: '70px', height: '100px', flexShrink: 0, marginBottom: '10px', position: 'relative' }}>
                                <img
                                    alt=""
                                    src={data.blob}
                                    style={{
                                        border: '1px solid gray',
                                        borderRadius: '10px',
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                    }}
                                />
                                {/* Кнопка удаления */}
                                <IconButton
                                    size="small"
                                    onClick={() => handleFileDel('photo')}
                                    sx={{
                                        position: 'absolute', top: -8, right: -8,
                                        backgroundColor: 'white', boxShadow: 2, width: '24px', height: '24px',
                                        "&:hover": { backgroundColor: "#f0f0f0" }, zIndex: 10
                                    }}
                                >
                                    <CloseIcon sx={{ fontSize: '16px', color: "red" }} />
                                </IconButton>
                                
                                {/* Скрытый инпут для смены фото кликом */}
                                <label htmlFor="change-image-edit" style={{ position: 'absolute', inset: 0, cursor: 'pointer', zIndex: 1 }} />
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    id="change-image-edit"
                                    onChange={(event) => { handleFileUpload(event, 'photo') }}
                                />
                            </div>
                        
                        ) : isLoading ? (
                        <div style={{ 
                            width: '70px', 
                            height: '105px', 
                            marginRight: '10px', 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            border: '1px solid lightgray', 
                            borderRadius:'10px' 
                            }}>
                                <div style={{ transform: 'scale(0.7)' }}><Loading></Loading></div>
                            </div>
                        )
                        :
                        <div style={{ width: '70px', height: '105px', marginRight: '10px' }}>
                            <input
                                type="file"
                                multiple
                                accept="application/png"
                                style={{ display: "none" }}
                                id="upload-image"
                                onChange={(event) => {handleFileUpload(event, 'photo')}}
                            />
                            <label 
                                htmlFor="upload-image" 
                                style={{ 
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%', 
                                    height: '100%',
                                    border: '1px solid gray', 
                                    borderRadius:'10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <img 
                                    alt="" 
                                    src={NoPhoto} 
                                    style={{ 
                                        maxWidth: '70px', 
                                        maxHeight: '70px', 
                                        width: '100%', 
                                        height: '100%',
                                        objectFit: 'contain'
                                    }}
                                ></img>
                            </label>
                        </div>
                    }
                    </>
                  }
                  <Box sx={{ maxWidth: '300px', display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {!parent && <TextInput title={"Название"} val={data?.title} onChange={(e) => editTextValue("title", e)}></TextInput>}
                  {!parent && <TextInput title={"Артикул"} val={data?.vendorCode} onChange={(e) => editTextValue("vendorCode", e)}></TextInput>}
                  <TextInput title={"Размер"} val={data?.size} onChange={(e) => editTextValue("size", e)}></TextInput>
                  {!edit && 
                    <>
                    <TextNumInput title={"Баркод"} val={data?.barcode} onChange={(e) => editTextValue("barcode", e)} maxCount={13}></TextNumInput>
                    <Typography sx={{lineHeight: "10px", fontSize: "10px", color: "red"}}>Если оставить поле пустым, баркод сгенерируется автоматически</Typography>
                    </>
                  }
                  {!parent && 
                    <>
                      <TextInput title={"Брэнд"} val={data?.brand} onChange={(e) => editTextValue("brand", e)}></TextInput>
                      <TextInput title={"Ссылка на товар"} val={data?.url} onChange={(e) => editTextValue("url", e)}></TextInput>
                      <div style={{marginTop: "10px"}}>
                        <Typography variant="body2">Цвет</Typography>
                        <Select
                          multiple
                          value={data?.color}
                          displayEmpty
                          inputProps={{ 'aria-label': 'Without label' }}
                          style={{
                              width:"300px",
                              borderRadius: "15px",
                              fontSize: "15px",
                              marginRight: "2px",
                              height: "40px"
                          }}
                          renderValue={(selected) => selected.map((el) => el).join(', ')}
                        >
                          {data?.color && data.color.map((el, index) => (
                            <MenuItem key={el.id} value={el}>
                              <div style={{width: '100%', display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                                <div style={{display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                                  <TextInput title={`Цвет ${index+1}`} val={el} onChange={(e) => editTextValue(`color[${index}]`, e)}></TextInput>
                                </div>
                                {el.static? <></>: 
                                <IconButton  aria-label="delImage" onClick={() => {delColor(index)}} 
                                  sx={{
                                    width: 40,
                                    height: 40,
                                  }}
                                >
                                    <DeleteIcon 
                                      sx={{
                                        transition: 'all 0.3s ease',
                                        '&:hover': hoverStyle
                                      }
                                    }/>
                                </IconButton>
                                }
                              </div>
                            </MenuItem>
                          ))}
                          <Button onClick={() => addNewColor()}>Добавить</Button>
                        </Select>
                      </div>
                      <div style={{marginTop: "10px"}}>
                        <Typography variant="body2">Материал</Typography>
                        <Select
                          multiple
                          value={data?.material}
                          displayEmpty
                          inputProps={{ 'aria-label': 'Without label' }}
                          style={{
                              width:"300px",
                              borderRadius: "15px",
                              fontSize: "15px",
                              marginRight: "2px",
                              height: "40px"
                          }}
                          renderValue={(selected) => selected.map((el) => el).join(', ')}
                        >
                          {data?.material && data.material.map((el, index) => (
                            <MenuItem key={el.id} value={el}>
                              <div style={{width: '100%', display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                                <div style={{display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                                  <TextInput title={`Материал ${index+1}`} val={el} onChange={(e) => editTextValue(`material[${index}]`, e)}></TextInput>
                                </div>
                                {el.static? <></>: 
                                <IconButton  aria-label="delImage" onClick={() => {delMaterial(index)}} 
                                  sx={{
                                    width: 40,
                                    height: 40,
                                  }}
                                >
                                    <DeleteIcon 
                                      sx={{
                                        transition: 'all 0.3s ease',
                                        '&:hover': hoverStyle
                                      }
                                    }/>
                                </IconButton>
                                }
                              </div>
                            </MenuItem>
                          ))}
                          <Button onClick={() => addNewMaterial()}>Добавить</Button>
                        </Select>
                      </div>
                      <NumInput title={"Длина"} val={data?.dimensions.length} onChange={(e) => editNumValue("dimensions.length", e)}></NumInput>
                      <NumInput title={"Ширина"} val={data?.dimensions.width} onChange={(e) => editNumValue("dimensions.width", e)}></NumInput>
                      <NumInput title={"Высота"} val={data?.dimensions.height} onChange={(e) => editNumValue("dimensions.height", e)}></NumInput>
                    </>
                  }
                  </Box>
              </div>
            </Scrollbars>

            {/* Нижняя панель с кнопками и полем ввода */}
            <Box

                sx={{
                    mt: 'auto',
                    p: 1,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                    borderRadius: 2,
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        width: "auto",
                        justifyContent: "flex-end",
                    }}
                >
                    <Button
                        onClick={preventDoubleClick(goBind, 1000)}
                        variant="contained"
                        size="medium"
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            px: 3,
                        }}
                    >
                        {edit? "Сохранить": "Добавить"}
                    </Button>
                    <Button
                        onClick={() => {
                          cancel(false); 
                          if (!parent && !edit) {
                            handleFileDel('photo')} 
                          }
                        }
                        variant="contained"
                        size="medium"
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            px: 3,
                            backgroundColor: "grey.500",
                            "&:hover": { backgroundColor: "grey.600" },
                        }}
                    >
                        Отмена
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}
